import { colorsPalettes } from "@similarweb/styles";
import { FlexColumn, OnOffSwitch, RadioButton } from "@similarweb/ui-components";

import type { SubscriptionProviderReturnType } from "app/pages/activation/context/Subscription/types";
import { translate } from "app/filters/i18nFilter";

import { generateAutomationName } from "../../../helpers/generateAutomationName";
import type { BenchmarkGranularity } from "../../../types/common";
import { TextWithInfoTooltip } from "../TextWithInfoTooltip/TextWithInfoTooltip";

import * as SC from "./styles";
import { BENCHMARK_DIGEST_TITLE, BENCHMARK_DIGEST_TITLE_TOOLTIP, FREQUENCY_TEXT, RECEIVE_TEXT } from "./texts";
import { ActivationSubscriptions } from "./types";

type BenchmarkDigestSubscriptionsSchema = {
    digestGranularity: SubscriptionProviderReturnType["digestGranularity"];
    granularityList: BenchmarkGranularity[];
    isSwitchedDigest: SubscriptionProviderReturnType["isSwitchedDigest"];
    onSwitch: SubscriptionProviderReturnType["onSwitch"];
    onSelect: SubscriptionProviderReturnType["onSelect"];
};

export const BenchmarkDigestSubscriptions = ({
    digestGranularity,
    granularityList,
    isSwitchedDigest,
    onSwitch,
    onSelect,
}: BenchmarkDigestSubscriptionsSchema) => {
    const onDigestSwitch = () => onSwitch(!isSwitchedDigest, ActivationSubscriptions.BenchmarkDigest);
    const onDigestGranularitySelect = (granularity: BenchmarkGranularity) => () =>
        onSelect(granularity, ActivationSubscriptions.BenchmarkDigest);

    return (
        <FlexColumn data-automation={generateAutomationName("settings", ["subscriptions", "digest", "container"])}>
            <TextWithInfoTooltip
                title={BENCHMARK_DIGEST_TITLE}
                tooltip={BENCHMARK_DIGEST_TITLE_TOOLTIP}
                iconColor={colorsPalettes.carbon[200]}
                marginBottom={4}
                dataAutomation={generateAutomationName("settings", ["subscriptions", "digest", "title"])}
            />

            <SC.SwitchWrapper
                data-automation={generateAutomationName("settings", [
                    "subscriptions",
                    "digest",
                    "switcher",
                    "container",
                ])}
            >
                <SC.SwitchLabel
                    onClick={onDigestSwitch}
                    data-automation={generateAutomationName("settings", [
                        "subscriptions",
                        "digest",
                        "switcher",
                        "label",
                    ])}
                >
                    {translate(RECEIVE_TEXT)}
                </SC.SwitchLabel>

                <OnOffSwitch
                    onClick={onDigestSwitch}
                    isSelected={isSwitchedDigest}
                    isDisabled={false}
                />
            </SC.SwitchWrapper>

            <SC.RadioGroupTitle
                data-automation={generateAutomationName("settings", [
                    "subscriptions",
                    "digest",
                    "radio",
                    "group",
                    "title",
                ])}
            >
                {translate(FREQUENCY_TEXT)}
            </SC.RadioGroupTitle>

            <SC.RadioGroup
                data-automation-isDisabled={!isSwitchedDigest}
                data-automation={generateAutomationName("settings", [
                    "subscriptions",
                    "digest",
                    "granularity",
                    "radio",
                    "group",
                    "container",
                ])}
            >
                {granularityList.map((granularity, id) => (
                    <RadioButton
                        itemDisabled={!isSwitchedDigest}
                        className="emailGranularity"
                        key={id}
                        itemLabel={granularity}
                        onClick={onDigestGranularitySelect(granularity)}
                        itemSelected={granularity === digestGranularity}
                    />
                ))}
            </SC.RadioGroup>
        </FlexColumn>
    );
};
